import React from 'react';
// import Translation from '../translation/translation';

function DriverReviewLightBoxHeader({ title }) {
    return (
        <div className="cross-sell-light-box__header cross-sell-light-box-header">
            <span className='cross-sell-remove-light-box-header__headline'>
                {title}
            </span>
        </div>
    );
}

export { DriverReviewLightBoxHeader };
